import React from 'react';
import dateFormat, { masks } from "dateformat";
class CostSheetMasterDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      
    <div>
      
      <p className='col1'>Notify:</p><p className='col2'>{this.props.data.data.Notify_Name}</p>
      <p className='col1'>Weight:</p><p className='col2'>{this.props.data.data.Weight}</p>
      <p className='col1'>Unit:</p><p className='col2'>{this.props.data.data.Weight_Unit}</p>
      <p className='col1'>Quantity:</p><p className='col2'>{this.props.data.data.Quantity}</p>
      <p className='col1'>Unit:</p><p className='col2'>{this.props.data.data.Quantity_Unit}</p>
      <p className='col1'>Container Qty:</p><p className='col2'>{this.props.data.data.Teus_Quantity}</p>
      <p className='col1'>HS Description:</p><p className='col2'>{this.props.data.data.HS_Description}</p>
      </div>
    );
  }
}

export default CostSheetMasterDetailView;
